// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nominate Jury Form Component Styles */
.nominate-jury-form-section {
  background-color: white;
  padding: 0 0 4rem 0;
}

.nominate-jury-form-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 9rem;
}

.nominate-jury-form {
  width: 100%;
}

/* Form validation field - completely hidden from users */
.form-validation-field {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

/* Country Dropdown Styles */
.country-dropdown-container {
  position: relative;
}

.country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
  max-height: 250px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.country-option {
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f0f0f0;
}

.country-option:hover {
  background-color: #f5f5f5;
}

.country-option:last-child {
  border-bottom: none;
}

.country-option.no-results {
  color: #999;
  font-style: italic;
  cursor: default;
}

.country-option.no-results:hover {
  background-color: transparent;
}

/* Form Grid Layout */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.form-field.half-width {
  grid-column: span 1;
}

/* Form Inputs */
.form-input {
  width: 100%;
  padding: 1rem 1.5rem;
  border: 2px solid var(--color-primary);
  border-radius: 0;
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-dark);
  background-color: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-input::placeholder {
  color: var(--color-primary);
  font-weight: 400;
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(230, 62, 150, 0.1);
}

.form-input.error {
  border-color: #dc3545;
}

/* Jury Form Sections */
.jury-form-section {
  margin-bottom: 2rem;
}

.jury-form-label {
  display: block;
  font-family: var(--font-family-primary);
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--color-text-dark);
  margin-bottom: 1rem;
}

.jury-section-title {
  font-family: var(--font-family-primary);
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--color-text-dark);
  margin-bottom: 1.5rem;
  margin-top: 0;
}

/* Textarea */
.form-textarea {
  width: 100%;
  padding: 1rem 1.5rem;
  border: 2px solid var(--color-primary);
  border-radius: 0;
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-dark);
  background-color: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
  resize: vertical;
  min-height: 150px;
}

.form-textarea:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(230, 62, 150, 0.1);
}

.form-textarea.error {
  border-color: #dc3545;
}

/* Character Counter */
.character-counter {
  font-family: var(--font-family-primary);
  font-size: 0.875rem;
  color: #666;
  text-align: right;
  margin-bottom: 0.5rem;
}

.character-counter.near-limit {
  color: #ff6b35;
  font-weight: 500;
}

.character-counter.at-limit {
  color: #dc3545;
  font-weight: 600;
}

/* Jury Checkbox Grid */
.jury-checkbox-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}

.jury-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 400;
  color: var(--color-text-dark);
  position: relative;
  padding-left: 2rem;
  transition: all 0.2s ease;
}

.jury-checkbox-label:hover {
  color: var(--color-primary);
}

.jury-checkbox-label input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.jury-checkmark {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 18px;
  background-color: white;
  border: 2px solid var(--color-primary);
  border-radius: 0;
  transition: all 0.3s ease;
}

.jury-checkbox-label:hover .jury-checkmark {
  background-color: rgba(230, 62, 150, 0.1);
}

.jury-checkbox-label input[type="checkbox"]:checked ~ .jury-checkmark {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.jury-checkbox-label input[type="checkbox"]:checked ~ .jury-checkbox-text {
  color: var(--color-text-dark);
  font-weight: 500;
}

.jury-checkbox-text {
  font-weight: 500;
  color: var(--color-text-dark);
}

/* Social Media Fields */
.social-media-field {
  margin-bottom: 1rem;
}

.social-media-input {
  display: flex;
  align-items: center;
  border: 2px solid var(--color-primary);
  border-radius: 0;
  overflow: hidden;
  background-color: white;
}

.social-media-prefix {
  background-color: var(--color-primary);
  color: white;
  padding: 0.75rem 1rem;
  font-family: var(--font-family-primary);
  font-size: 1rem;
  font-weight: 500;
  white-space: nowrap;
  min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-input {
  border: none;
  border-radius: 0;
  flex: 1 1;
  padding: 0.75rem 1rem;
}

.social-input:focus {
  border: none;
  box-shadow: none;
}

/* Submit Button */
.form-submit {
  text-align: center;
  margin-top: 3rem;
}

.submit-button {
  background-color: var(--color-primary);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 1.25rem 4rem;
  font-family: var(--font-family-primary);
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.submit-button:hover {
  background-color: #B91C7C;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.submit-button:disabled:hover {
  background-color: var(--color-primary);
  transform: none;
  box-shadow: none;
}

/* Error Messages */
.error-message {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  font-family: var(--font-family-primary);
}

/* Submit Messages */
.submit-message {
  padding: 1rem 1.5rem;
  border-radius: 0;
  margin-bottom: 2rem;
  font-family: var(--font-family-primary);
  font-weight: 500;
  text-align: center;
}

.submit-message.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.submit-message.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

/* Responsive Design */
@media (max-width: 768px) {
  .nominate-jury-form-section {
    padding: 0 0 3rem 0;
  }

  .nominate-jury-form-container {
    padding: 0 6rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .form-field.half-width {
    grid-column: span 1;
  }

  .jury-checkbox-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .jury-checkmark {
    height: 16px;
    width: 16px;
  }

  .social-media-prefix {
    padding: 0.75rem;
    font-size: 0.9rem;
    min-width: 140px;
  }

  .form-input,
  .form-textarea {
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
  }

  .submit-button {
    padding: 1rem 2rem;
    font-size: 1rem;
    min-width: 160px;
  }
}

@media (max-width: 500px) {
  .nominate-jury-form-container {
    padding: 0 4rem;
  }

  .form-input,
  .form-textarea {
    padding: 0.625rem;
    font-size: 0.9rem;
  }

  .jury-form-label,
  .jury-section-title {
    font-size: 1rem;
  }

  .social-media-prefix {
    padding: 0.625rem;
    font-size: 0.85rem;
    min-width: 130px;
  }

  .submit-button {
    width: 100%;
    padding: 1rem;
  }
}

@media (max-width: 320px) {
  .nominate-jury-form-container {
    padding: 0 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NominateJuryForm/NominateJuryForm.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;EACvC,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,qBAAqB;EACrB,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,uCAAuC;EACvC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Nominate Jury Form Component Styles */\n.nominate-jury-form-section {\n  background-color: white;\n  padding: 0 0 4rem 0;\n}\n\n.nominate-jury-form-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 0 9rem;\n}\n\n.nominate-jury-form {\n  width: 100%;\n}\n\n/* Form validation field - completely hidden from users */\n.form-validation-field {\n  position: absolute;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Country Dropdown Styles */\n.country-dropdown-container {\n  position: relative;\n}\n\n.country-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  max-height: 250px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.country-option {\n  padding: 10px 15px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.country-option:hover {\n  background-color: #f5f5f5;\n}\n\n.country-option:last-child {\n  border-bottom: none;\n}\n\n.country-option.no-results {\n  color: #999;\n  font-style: italic;\n  cursor: default;\n}\n\n.country-option.no-results:hover {\n  background-color: transparent;\n}\n\n/* Form Grid Layout */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.form-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-field.half-width {\n  grid-column: span 1;\n}\n\n/* Form Inputs */\n.form-input {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  border: 2px solid var(--color-primary);\n  border-radius: 0;\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  background-color: white;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-input::placeholder {\n  color: var(--color-primary);\n  font-weight: 400;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(230, 62, 150, 0.1);\n}\n\n.form-input.error {\n  border-color: #dc3545;\n}\n\n/* Jury Form Sections */\n.jury-form-section {\n  margin-bottom: 2rem;\n}\n\n.jury-form-label {\n  display: block;\n  font-family: var(--font-family-primary);\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--color-text-dark);\n  margin-bottom: 1rem;\n}\n\n.jury-section-title {\n  font-family: var(--font-family-primary);\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: var(--color-text-dark);\n  margin-bottom: 1.5rem;\n  margin-top: 0;\n}\n\n/* Textarea */\n.form-textarea {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  border: 2px solid var(--color-primary);\n  border-radius: 0;\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  background-color: white;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 150px;\n}\n\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(230, 62, 150, 0.1);\n}\n\n.form-textarea.error {\n  border-color: #dc3545;\n}\n\n/* Character Counter */\n.character-counter {\n  font-family: var(--font-family-primary);\n  font-size: 0.875rem;\n  color: #666;\n  text-align: right;\n  margin-bottom: 0.5rem;\n}\n\n.character-counter.near-limit {\n  color: #ff6b35;\n  font-weight: 500;\n}\n\n.character-counter.at-limit {\n  color: #dc3545;\n  font-weight: 600;\n}\n\n/* Jury Checkbox Grid */\n.jury-checkbox-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.jury-checkbox-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--color-text-dark);\n  position: relative;\n  padding-left: 2rem;\n  transition: all 0.2s ease;\n}\n\n.jury-checkbox-label:hover {\n  color: var(--color-primary);\n}\n\n.jury-checkbox-label input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.jury-checkmark {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  height: 18px;\n  width: 18px;\n  background-color: white;\n  border: 2px solid var(--color-primary);\n  border-radius: 0;\n  transition: all 0.3s ease;\n}\n\n.jury-checkbox-label:hover .jury-checkmark {\n  background-color: rgba(230, 62, 150, 0.1);\n}\n\n.jury-checkbox-label input[type=\"checkbox\"]:checked ~ .jury-checkmark {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.jury-checkbox-label input[type=\"checkbox\"]:checked ~ .jury-checkbox-text {\n  color: var(--color-text-dark);\n  font-weight: 500;\n}\n\n.jury-checkbox-text {\n  font-weight: 500;\n  color: var(--color-text-dark);\n}\n\n/* Social Media Fields */\n.social-media-field {\n  margin-bottom: 1rem;\n}\n\n.social-media-input {\n  display: flex;\n  align-items: center;\n  border: 2px solid var(--color-primary);\n  border-radius: 0;\n  overflow: hidden;\n  background-color: white;\n}\n\n.social-media-prefix {\n  background-color: var(--color-primary);\n  color: white;\n  padding: 0.75rem 1rem;\n  font-family: var(--font-family-primary);\n  font-size: 1rem;\n  font-weight: 500;\n  white-space: nowrap;\n  min-width: 160px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.social-input {\n  border: none;\n  border-radius: 0;\n  flex: 1;\n  padding: 0.75rem 1rem;\n}\n\n.social-input:focus {\n  border: none;\n  box-shadow: none;\n}\n\n/* Submit Button */\n.form-submit {\n  text-align: center;\n  margin-top: 3rem;\n}\n\n.submit-button {\n  background-color: var(--color-primary);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 1.25rem 4rem;\n  font-family: var(--font-family-primary);\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.submit-button:hover {\n  background-color: #B91C7C;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.submit-button:disabled:hover {\n  background-color: var(--color-primary);\n  transform: none;\n  box-shadow: none;\n}\n\n/* Error Messages */\n.error-message {\n  display: block;\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n  font-family: var(--font-family-primary);\n}\n\n/* Submit Messages */\n.submit-message {\n  padding: 1rem 1.5rem;\n  border-radius: 0;\n  margin-bottom: 2rem;\n  font-family: var(--font-family-primary);\n  font-weight: 500;\n  text-align: center;\n}\n\n.submit-message.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.submit-message.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .nominate-jury-form-section {\n    padding: 0 0 3rem 0;\n  }\n\n  .nominate-jury-form-container {\n    padding: 0 6rem;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .form-field.half-width {\n    grid-column: span 1;\n  }\n\n  .jury-checkbox-grid {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n  }\n\n  .jury-checkmark {\n    height: 16px;\n    width: 16px;\n  }\n\n  .social-media-prefix {\n    padding: 0.75rem;\n    font-size: 0.9rem;\n    min-width: 140px;\n  }\n\n  .form-input,\n  .form-textarea {\n    padding: 0.875rem 1rem;\n    font-size: 0.95rem;\n  }\n\n  .submit-button {\n    padding: 1rem 2rem;\n    font-size: 1rem;\n    min-width: 160px;\n  }\n}\n\n@media (max-width: 500px) {\n  .nominate-jury-form-container {\n    padding: 0 4rem;\n  }\n\n  .form-input,\n  .form-textarea {\n    padding: 0.625rem;\n    font-size: 0.9rem;\n  }\n\n  .jury-form-label,\n  .jury-section-title {\n    font-size: 1rem;\n  }\n\n  .social-media-prefix {\n    padding: 0.625rem;\n    font-size: 0.85rem;\n    min-width: 130px;\n  }\n\n  .submit-button {\n    width: 100%;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 320px) {\n  .nominate-jury-form-container {\n    padding: 0 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
